function passwordscoremin() {
    return 3 >=3 ;
  }
  
  
  export { passwordscoremin };